import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO15 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK001-5.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO15
